/* screens/academy/TabScroller.jsx — признак горизонтальной прокрутки у полосы вкладок.

   На узком экране .acad-tabs скроллится по горизонтали (academy-console.css), но
   ничем этого не показывала: на 380px из 654px полосы видно 380, и вкладки за
   краем для методиста просто не существовали — он читал видимые пять и уходил.
   Обёртка гасит тот край, за которым спрятан контент, и убирает подсказку, когда
   прокручивать больше некуда.

   Почему отдельный модуль, а не хелпер внутри консоли: полос три — фильтры очереди
   (AcademyConsole), статусы заказов (OrdersTab) и вкладки курса (CourseEditor);
   держать общий компонент в одном из экранов значило бы завести цикл импортов
   между ними. Почему инлайновые стили: лист .acad-tabs общий, а затухание нужно
   ровно этим полосам. */
import React from 'react';

const { useRef, useState, useCallback, useEffect } = React;

function TabScroller({ children }) {
  const ref = useRef(null);
  const [edge, setEdge] = useState({ left: false, right: false });

  const sync = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    const max = el.scrollWidth - el.clientWidth;
    // Порог в 1px — защита от дробной ширины после зума/масштабирования шрифта:
    // на ней scrollLeft никогда не равен max ровно, и правое затухание не гасло бы.
    setEdge({ left: el.scrollLeft > 1, right: max > 1 && el.scrollLeft < max - 1 });
  }, []);

  useEffect(() => {
    sync();
    const el = ref.current;
    if (!el) return undefined;
    el.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    return () => {
      el.removeEventListener('scroll', sync);
      window.removeEventListener('resize', sync);
    };
  }, [sync, children]);

  const fade = (side) => ({
    position: 'absolute', top: 0, bottom: 0, [side]: 0, width: 28,
    borderRadius: 'var(--radius-pill)', pointerEvents: 'none',
    background: `linear-gradient(to ${side}, var(--surface), transparent)`,
  });

  return (
    <div style={{ position: 'relative', minWidth: 0, maxWidth: '100%' }}>
      {/* ref вешаем на САМУ полосу: скроллится .acad-tabs, а не обёртка. */}
      {React.isValidElement(children) ? React.cloneElement(children, { ref }) : children}
      {edge.left && <span aria-hidden="true" style={fade('left')} />}
      {edge.right && <span aria-hidden="true" style={fade('right')} />}
    </div>
  );
}

export { TabScroller };
